import React from "react";

function DocusignSuccess(props) {
  return (
    <div>
      <h4>Document was successfully updated.</h4>
      You may close this window.
    </div>
  );
}

export default DocusignSuccess;
